module.exports = ko.validation;